<template>
    <div>
        <Ending v-if="flatEndings" :difficulty-label="label" v-bind="endings[0]" />
        <a-collapse v-else v-model="activeEndings" :bordered="false">
            <a-collapse-panel
                v-for="ending of endings" :key="ending.name"
            >
                <span slot="header" class="header">
                    {{ ending.name }}
                    <span v-if="ending.verifiedOnly" class="verified-only">
                        该结局只显示绿名录像
                    </span>
                </span>
                <Ending :difficulty-label="label" v-bind="ending" />
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Ending from './Ending.vue'

export default {
    props: {
        endings: Array,
        label: String,
    },
    data: () => ({
        activeEndings: [],
    }),
    computed: {
        flatEndings() {
            if (this.endings.length === 1 && this.endings[0].name === '') {
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        this.activeEndings = this.endings
            .filter(e => (Number(e.fold) === 0))
            .map(e => e.name);
    },
    methods: {

    },
    components: {
        Ending,
    },
}
</script>

<style lang="less" scoped>
.header {
    font-size: 16px;
}
.verified-only {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
}
</style>